module.exports = __webpack_public_path__ + "media/newstyle/images/after-02-2a4d75aeadcc5e5a6dff6ef5ac1435c9.png";